import React, { useEffect, useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { accordionData as localAccordionData } from "constants/accordionData.js";
import AccordionItem from "components/accordion/AccordionItem";
import axios from "axios";
import { isArray, isEmpty } from "lodash";

const FAQ = () => {
  const [faqData, setFaqData] = useState([]);
  const [scrollKey, setScrollKey] = useState(0);
  const [activeKey, setActiveKey] = useState(null);
  const scrollRef = useRef([]);

  const scrollToElement = (index) => {
    setScrollKey(index);
    if (scrollRef?.current[index] && scrollKey) {
      scrollRef?.current[index]?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const fetchFAQs = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CMS_BASE_URL}/digital-faqs?populate=*&sort=createdAt:asc`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
          },
        }
      );

      setFaqData(response.data.data);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    fetchFAQs();
  }, []);

  useEffect(() => {
    const hash = window.location.hash.substring(1); // Remove the '#' character
    if (hash === "developer-mode" && !isEmpty(faqData)) {
      // scrollToElement(1);
      const section = document.querySelector('#developer-mode');
      var headerOffset = 250;
      var elementPosition = section?.getBoundingClientRect().top;
      var offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
      });
      // setActiveKey("391");
    }
  }, [faqData]); // Run on component mount

  return (
    <section
      className="call-to-action"
      id="faq"
      style={{
        background: "#ffffff",
        marginTop: "25px",
        height: "max-content",
      }}
    >
      <style>
        {`
        h1 {
          font-size: 3rem;
          font-weight: 700;
        }
        .padding-bottom {
          padding-bottom: 50px; 
        }
        `}
      </style>
      <div className="container px-3">
        <div className="padding-bottom">
          <h1>FAQs</h1>
        </div>
        {isArray(faqData) &&
          faqData.map((data, index) => {
            return (
              <div className="padding-bottom">
                <h5>
                  <b>
                    <u>{data.title}</u>
                  </b>
                </h5>
                <AccordionItem key={data.id} data={data.faqData} scrollRef={scrollRef} scrollKey={scrollKey} activeKey={activeKey} />
              </div>
            )
          })}
      </div>
      {/* <div className="container px-3">
        <div className="padding-bottom">
          <h1>FAQs</h1>
        </div>
        <div className="padding-bottom">
          <h5>
            <b>
              <u>General (Applications, Devices, Requirements)</u>
            </b>
          </h5>
          <AccordionItem data={accordionData?.general} />
        </div>
        <div className="padding-bottom">
          <h5>
            <b>
              <u>Account & Cards</u>
            </b>
          </h5>
          <AccordionItem data={accordionData?.accounts} />
        </div>
        <div className="padding-bottom">
          <h5>
            <b>
              <u>Fund Transfers</u>
            </b>
          </h5>
          <AccordionItem data={accordionData?.funds} />
        </div>
        <div className="padding-bottom">
          <h5>
            <b>
              <u>Savings Pot</u>
            </b>
          </h5>
          <AccordionItem data={accordionData?.savings} />
        </div>
        <div className="padding-bottom" id="security" ref={securityRef}>
          <h5>
            <b>
              <u>Security</u>
            </b>
          </h5>
          <AccordionItem
            data={accordionData?.security}
            accordionName="security"
            activeKey={activeKey}
            onChange={setActiveKey}
          />
        </div>
        <div className="padding-bottom">
          <h5>
            <b>
              <u>Personal Financing</u>
            </b>
          </h5>
          <AccordionItem data={accordionData?.pf} />
        </div>
        <div className="padding-bottom">
          <h5>
            <b>
              <u>Contact</u>
            </b>
          </h5>
          <AccordionItem data={accordionData?.contact} />
        </div>
        <div className="padding-bottom">
          <h5>
            <b>
              <u>Kill Switch</u>
            </b>
          </h5>
          <AccordionItem data={accordionData?.killswitch} />
        </div>
        <div className="padding-bottom">
          <h5>
            <b>
              <u>Cooling Off Period</u>
            </b>
          </h5>
          <AccordionItem data={accordionData?.coolingoff} />
        </div>
        <div className="padding-bottom">
          <h2>
            <b>
              <u>Important Documents</u>
            </b>
          </h2>
          <AccordionItem data={accordionData?.docs} />
        </div>
        <div className="padding-bottom">
          <h2>
            <b>
              <u>Important Notices</u>
            </b>
          </h2>
          <AccordionItem data={accordionData?.notices} />
        </div>
        <div className="padding-bottom">
          <h2>
            <b>
              <u>January 2023</u>
            </b>
          </h2>
          <AccordionItem data={accordionData?.jan23} />
        </div>
        <div className="padding-bottom">
          <h2>
            <b>
              <u>June 2023</u>
            </b>
          </h2>
          <AccordionItem data={accordionData?.june23} />
        </div>
        <div className="padding-bottom">
          <h2>
            <b>
              <u>January 2024</u>
            </b>
          </h2>
          <AccordionItem data={accordionData?.jan24} />
        </div>
        <div className="padding-bottom">
          <h2>
            <b>
              <u>April 2024</u>
            </b>
          </h2>
          <AccordionItem data={accordionData?.apr24} />
        </div>
        <div className="padding-bottom">
          <h2>
            <b>
              <u>May 2024</u>
            </b>
          </h2>
          <AccordionItem data={accordionData?.may24} />
        </div>
        <div className="padding-bottom">
          <h2>
            <b>
              <u>July 2024</u>
            </b>
          </h2>
          <AccordionItem data={accordionData?.jul24} />
        </div>
        <div className="padding-bottom">
          <h2>
            <b>
              <u>Campaigns</u>
            </b>
          </h2>
          <AccordionItem data={accordionData?.campaigns} />
        </div>
        <div className="padding-bottom">
          <h2>
            <b>
              <u>Media</u>
            </b>
          </h2>
          <AccordionItem data={accordionData?.media} />
        </div>
      </div> */}
    </section>
  );
};

export default FAQ;
